<template>
  <div class="OnlyReplenshipment">
    <div class="OnlyReplenshipmentContainer">
      <template>
        <div class="ratePlanIsTryBuyModal">
          <h3 class="text"  v-if="currentCountryCode === 'DE' && this.subscriptionDetails.bundleName === 'MCC-4B-SCF39531-M-EVERGREEN' || currentCountryCode === 'DE' && this.subscriptionDetails.bundleName === 'MCC-4B-SCF39731-M-EVERGREEN' || this.subscriptionDetails.bundleName === 'MCC-4B-SCF53711-M-EVERGREEN'">
            {{ $t('subscription_return.cancelOrReturn.textnew', 'So senden Sie Ihre Milchpumpe zurück und kündigen Ihr Abonnement') }}
          </h3>
          <div v-if="currentCountryCode === 'DE' && this.subscriptionDetails.bundleName === 'MCC-4B-SCF39531-M-EVERGREEN' || currentCountryCode === 'DE' && this.subscriptionDetails.bundleName === 'MCC-4B-SCF39731-M-EVERGREEN' || this.subscriptionDetails.bundleName === 'MCC-4B-SCF53711-M-EVERGREEN'" 
          v-html="$t('subscription_return.cancelOrReturn.textnew1', '')">
          </div>
          <div class ="ispdf" v-if="currentCountryCode === 'DE' && this.subscriptionDetails.bundleName === 'MCC-4B-SCF39531-M-EVERGREEN' || currentCountryCode === 'DE' && this.subscriptionDetails.bundleName === 'MCC-4B-SCF39731-M-EVERGREEN' || this.subscriptionDetails.bundleName === 'MCC-4B-SCF53711-M-EVERGREEN'">
            <a
          href="/Widerrufsformular.pdf" target="new">
          <h3 download style="text-decoration: underline;" > 
        {{ $t('subscription_return.cancelOrReturn.textnew3', 'So senden') }}</h3>
        </a></div>        
          <h3 class="text" v-if = " (subscriptionDetails.bundleName !== 'MCC-4B-SCF39531-M-EVERGREEN'&& currentCountryCode === 'DE') && (currentCountryCode === 'DE' && subscriptionDetails.bundleName !== 'MCC-4B-SCF39731-M-EVERGREEN')&& (currentCountryCode === 'DE' && subscriptionDetails.bundleName !==  'MCC-4B-SCF53711-M-EVERGREEN')">
            {{ $t('subscription_return.cancelOrReturn.textNew', 'Cancel the subscription and return the product') }}
          </h3>

          <h3 class="text" v-if = "currentCountryCode !== 'DE'">
            {{ $t('subscription_return.cancelOrReturn.text', 'Cancel the subscription and return the product') }}
          </h3>

          <p class="tips" v-if="subscriptionDetails.shippingConfirmed === false">
            {{ $t('subscription_return.cancelOrReturn.tips1', 'Your order is almost ready to ship and cannot be canceled through your online account at this time. Please contact our customer service who are happy to help. Contact details available at the Support section') }}
          </p>

          <p class="tips" v-if="subscriptionDetails.shippingConfirmed === true && (subscriptionDetails.bundleName !== 'MCC-4B-SCF39531-M-EVERGREEN') && (subscriptionDetails.bundleName !== 'MCC-4B-SCF39731-M-EVERGREEN')&& (subscriptionDetails.bundleName !==  'MCC-4B-SCF53711-M-EVERGREEN')">
            {{ $t('subscription_return.cancelOrReturn.tips', 'Sorry to see you go. With this option you will cancel your subscription and return the product you have received.') }}
          </p>

          <p class="tips" v-if="subscriptionDetails.shippingConfirmed === true && (subscriptionDetails.bundleName !== 'MCC-4B-SCF39531-M-EVERGREEN') && (subscriptionDetails.bundleName !== 'MCC-4B-SCF39731-M-EVERGREEN')&& (subscriptionDetails.bundleName !==  'MCC-4B-SCF53711-M-EVERGREEN')">
            {{ $t('subscription_return.cancelOrReturn.subTips', "Please note that your subscription is not cancelled until we've received the return.") }}
          </p>

          <app-button
           v-if="subscriptionDetails.shippingConfirmed === true"
            type="submit"
            class="cancelProcess"
            @click.prevent="startReturnOnlyTryBuy"
          >
            {{ $t('subscription_return.cancelOrReturn.button.process', "Process") }}
          </app-button>
        </div>
      </template>

      <div class="OnlyReplenshipment_steps">
        <!-- subscriptionDetails.returnable -> tryBuyCanDoReturn -->
        <div class="InsideRemorsePeriod">
          <app-modal name="step2" @after-closed="emptyCancelData">
            <div class="v--modal-content">
              <h3 class="modal-title">
              </h3>
              <div class="modal-content">
                <div class="CancleSubscription_ReasonForm">
                  <h4>
                    {{ $t('subscription_details.accordion.cancel.form.reason', 'Reason for cancelling') }}
                  </h4>

                  <div class="CheckboxGroup">
                    <app-checkbox
                      v-for="(item, index) in cancelReason"
                      :key="index"
                      :id="'reason' + (index + 1)"
                      :label="item.text"
                      :value="item.checked"
                      @input="item.checked = $event"
                    />
                  </div>

                  <app-textarea
                    :placeholder="$t('subscription_details.accordion.cancel.form.textarea', 'Please tell us more')"
                    v-model.trim="cancelMoreInfo"
                    maxlength="200"
                  />

                  <div class="modal-button-warpper">
                    <app-button
                      @click="closeModalStep2"
                      :disabled="!cancelReasonSelected && !cancelMoreInfo"
                      class="cancel_closeModal"
                    >
                      {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.cancel', 'Cancel') }}
                    </app-button>

                    <app-button
                      @click.prevent="openModalStep2.run()"
                      :disabled="!cancelReasonSelected && !cancelMoreInfo"
                      :is-loading="openModalStep2.isActive"
                      class="cancel_openModal"
                    >
                      {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.proceed', 'Proceed') }}
                    </app-button>
                  </div>
                </div>
              </div>
            </div>
          </app-modal>

          <div class="returnSubscription">
            <app-modal name="step3" @after-closed="emptyCancelData">
              <div class="v--modal-content">
                <h3 class="modal-title">
                </h3>
                <div class="modal-content">
                  <div class="CancleSubscription_ReasonForm">
                    <p class="title">
                      <span>{{ $t('subscription_details.device.return.title', 'What happens next?') }}</span>
                    </p>

                    <p class="tips">
                      <span>{{ $t('subscription_details.device.return.return.tips', 'As soon as we have received your product(s), your cancellation will be confirmed.') }}</span>
                    </p>

                    <p class="tips">
                      <span>{{ $t('subscription_details.device.return.info', 'We have sent you an email at') }}</span>
                      <b> {{ consumerEmail }} </b>,
                      <span>{{ $t('subscription_details.device.return.subInfo', 'with a return label and instructions on how to send the product back to us for free.') }}</span>
                    </p>

                    <div class="modal-button-warpper">
                      <app-button
                        type="submit"
                        @click.prevent="cancelOrReturnOnlyReplenishmentTask.run()"
                        :is-loading="cancelOrReturnOnlyReplenishmentTask.isActive"
                        class="cancel_openModal"
                      >
                        {{ $t('subscription_details.accordion.cancel.onlyReplenishment.button.ok', 'OK') }}
                      </app-button>
                    </div>
                  </div>
                </div>
              </div>
            </app-modal>
          </div>
        </div>
      </div>

      <!--checkReturnAddress  -->
      <app-modal name="checkReturnAddress" @after-closed="emptyCancelData">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="CancleSubscription_ReasonForm">
              <p class="title">
                <span>{{ $t('subscription_return.cancelOrReturn.popUp.device.confirmAddress.title', 'Confirm your current address') }}</span>
              </p>

              <p class="tips">
                <span>{{ $t('subscription_return.cancelOrReturn.popUp.device.confirmAddress.tips', 'We will send you a pre-addressed return label for you to easily return the product. Please check if your contact details are up to date.') }}</span>
              </p>

               <div
                    class="SelectGroup Form_group return_address"
                    v-if="currentCountryCode === 'GB'"
                    :class="{'error': errorsFor('county').length > 0}">
                   
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('subscription_return.cancelOrReturn.popUp.device.confirmAddress.tips2', 'Select your Region*' )"
                      v-model="stateCode"
                      :options="region"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="submitUpdateReturnAddress.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>

              <p class="update_address_success" v-if="updateAddressSuccess">
                <span>{{ $t('subscription_return.cancelOrReturn.popUp.device.confirmAddress.updateAddress.success.tip', 'Address successfully updated') }}</span>
              </p>

              <div class="address">
                <div>
                  <app-edit-button
                    class="address_edit"
                    data-name="verifyAddress-editButton"
                    :disabled="!stateCode && currentCountryCode === 'GB'"
                    @click.prevent="editAddress"
                  />
                </div>
                <div class="address_content">
                  <template v-if="currentCountryCode === 'GB'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'ES'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                     <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name  }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'FR'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'SE'">
                    <p>{{ line1 }}</p>
                    <p>{{ line2 }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'RO'">
                    <p>{{ line1 }}</p> 
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name  }}</p>
                    </template>
                    <template v-if="currentCountryCode === 'CZ'">
                    <p>{{ line1 }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'IT'">
                    <p>{{ line1 }}</p> 
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'AT'">
                    <p>{{ line1 }}</p>  
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p> 
                  </template>
                  <template v-if="currentCountryCode === 'BE'">
                    <p>{{ line1 }}</p> 
                    <p>{{ houseNumber }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p> 
                  </template>
                  <template v-if="currentCountryCode === 'DE'">
                    <p>{{ addition }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
                    <p>{{ addition }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                    <p>{{ selectedCountryState && selectedCountryState.name }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'PL'">
                    <p>{{ street }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ extension }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                  <template v-if="currentCountryCode === 'NL'">
                    <p>{{ street }}</p>
                    <p>{{ houseNumber }}</p>
                    <p>{{ extension }}</p>
                    <p>{{ zipCode }}</p>
                    <p>{{ city }}</p>
                  </template>
                </div>
              </div>

              <div class="modal-button-warpper">
                <app-button
                  type="submit"
                  @click.prevent="cancleSubmitCheckReturnAddress"
                  class="cancel_closeModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.button.cancel', 'Cancel') }}
                </app-button>
                <app-button
                  type="submit"
                  :disabled="!stateCode && currentCountryCode === 'GB'"
                  @click.prevent="submitCheckReturnAddress"
                  class="cancel_openModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.button.processed', 'Proceed') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      <!-- updateReturnAddress -->
      <app-modal name="step5" @after-closed="emptyCancelData" class="address_form_edit">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="CancleSubscription_ReasonForm">
              <p class="title">
                {{ $t('subscription_details.cancelOrReturn.popUp.confirmAddress.button.edit.text', 'Edit address') }}
              </p>

              <div class="addressForm">
                <template v-if="currentCountryCode === 'GB' || currentCountryCode === 'ES' || currentCountryCode === 'BE' || currentCountryCode === 'IT' || currentCountryCode === 'AT' || currentCountryCode === 'RO' || currentCountryCode === 'CZ'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    v-if ="selectedCountry.code === 'ES' || selectedCountry.code === 'BE' || selectedCountry.code === 'IT' || selectedCountry.code === 'AT' || currentCountryCode === 'RO' || currentCountryCode === 'CZ'"
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number*')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />
                   <app-text-input
                    v-if="selectedCountry && (selectedCountry.code === 'ES' || selectedCountry.code === 'GB')"
                    class="return_address"
                    v-model.trim="line2"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                  <div 
                    class="SelectGroup Form_group return_address" 
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'GB' || selectedCountry && selectedCountry.states && currentCountryCode === 'IT' || selectedCountry && selectedCountry.states && currentCountryCode === 'ES'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="Form_label">{{ $t('common.address.textLable.country', 'Country') }}</label>
                    <!-- <app-text-input
                      v-if="!editable"
                      class="no-border no-padding return_address"
                      :value="selectedCountry && selectedCountry.name"
                      :disabled="!editable"
                      data-name="verifyAddress-selectcountry"
                    /> -->
                    <app-select
                      :placeholder="$t('common.address.placeholder.state', 'Select your state')"
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectedCountryState"
                      :id="selectedCountry.code"
                      :disabled="submitUpdateReturnAddress.isActive"
                      @search-change="searchState"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountry')" :key="index">
                      {{ $t('common.address.textLable.country', 'Country') }} {{ error }}
                    </p>
                    <!-- <app-text-input
                      v-if="editable && countries.length == 1"
                      class="no-border no-padding return_address"
                      :value="county"
                      disabled="disabled"
                      data-name="verifyAddress-selectcountry"
                    /> -->
                  </div>

                    <!-- <div
                    class="SelectGroup Form_group return_address"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'ES'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="Form_label">{{ $t('common.address.textLable.Provincia', 'Provincia') }}</label>
                    <app-select
                      :placeholder="$t('common.address.placeholder.state', 'Select your state')"
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectedCountryState"
                      :id="selectedCountry.code"
                      :disabled="submitUpdateReturnAddress.isActive"
                      @search-change="searchState"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryState')" :key="index">
                      {{ $t('common.address.textLable.state', 'State') }} {{ error }}
                    </p>
                  </div>  -->
                </template>
                <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    v-model.trim="line1"
                    :errors="errorsFor('line1')"
                  />
                  <app-text-input
                    class="return_address"
                    v-model.trim="line2"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2*')"
                    :errors="errorsFor('line2')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number*')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                  />
                </template>
                <template v-if="currentCountryCode === 'DE'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                    v-model.trim="addition"
                    :errors="errorsFor('addition')"
                    data-name="verifyAddress-addition"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                </template>
                <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                    v-model.trim="addition"
                    :errors="errorsFor('addition')"
                    data-name="verifyAddress-addition"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                  <div
                    class="SelectGroup Form_group return_address"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'US'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="Form_label">{{ $t('common.address.textLable.state', 'State') }}</label>
                    <app-select
                      :placeholder="$t('common.address.placeholder.state', 'Select your state')"
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectedCountryState"
                      :id="selectedCountry.code"
                      :disabled="submitUpdateReturnAddress.isActive"
                      @search-change="searchState"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryState')" :key="index">
                      {{ $t('common.address.textLable.state', 'State') }} {{ error }}
                    </p>
                  </div>
                  <div
                    class="SelectGroup Form_group return_address"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'CA'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="Form_label">{{ $t('common.address.textLable.province', 'Province') }}</label>
                    <app-select
                      :placeholder="$t('common.address.placeholder.province', 'Select your province')"
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      data-name="verifyAddress-selectedCountryState"
                      :id="selectedCountry.code"
                      :disabled="submitUpdateReturnAddress.isActive"
                      @search-change="searchState"
                    />
                    <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryState')" :key="index">
                      {{ $t('common.address.textLable.province', 'Province') }} {{ error }}
                    </p>
                  </div>
                </template>
                <template v-if="currentCountryCode === 'PL'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="verifyAddress-street"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />

                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                </template>
                <template v-if="currentCountryCode === 'NL'">
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="verifyAddress-street"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                  />

                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="verifyAddress-zipCode"
                  />
                  <app-text-input
                    class="return_address"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="verifyAddress-city"
                  />
                </template>
              </div>

              <div class="modal-button-warpper updateAddressButton">
                <app-button
                  type="submit"
                  :is-loading="submitUpdateReturnAddress.isActive"
                  @click.prevent="submitUpdateReturnAddress.run()"
                  class="cancel_openModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.button.save', 'Save') }}
                </app-button>
                <app-button
                  type="submit"
                  @click.prevent="cancelUpdateReturnAddress.run()"
                  :is-loading="cancelUpdateReturnAddress.isActive"
                  class="cancel_closeModal"
                >
                  {{ $t('subscription_return.cancelOrReturn.popUp.confirmAddress.button.cancel', 'Cancel') }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { cloneDeep } from 'lodash'
  import { mapValueProperties, getErrors, extractErrorMessage } from '@/utilities/common'
  import { includeNumberRegex, addressRegex } from '@/utilities/common/validators'
  import { required, maxLength, minLength } from 'vuelidate/lib/validators'
  import Vue from 'vue'
  import { detectedCulture } from 'utilities/common/culture'
  import ReturnCommonMixin from 'mixins/return-general'
  import {
    region
 } from 'utilities/cluture/region'

  export default {
    name: 'only-device',

    mixins: [ReturnCommonMixin],

    data () {
      return {
        currentIndex: -1,
        cancelReason: [],
        cancelMoreInfo: '',
        step1Show: false,
        hideChecked: false,
        address: {},
        editable: false,
        preEditAddress: {},
        updateAddressSuccess: false,
        currentCountryCode: detectedCulture.countryCode,
        region: region[detectedCulture.countryCode],
      }
    },

    validations () {
      let AddressObject
      if (this.currentCountryCode === 'GB' || this.currentCountryCode === 'ES' || this.currentCountryCode === 'BE' || this.currentCountryCode === 'IT' || this.currentCountryCode === 'AT' || this.selectedCountry.code === 'RO' || this.selectedCountry.code === 'CZ') {
        AddressObject = {
          line1: {
            required,
             Addressline1 (value) { 
            if(this.selectedCountry.code === 'ES' || this.selectedCountry.code === 'AT' || this.selectedCountry.code === 'FR' || this.selectedCountry.code === 'SE' || this.selectedCountry.code === 'BE'){
              if (!value) return true
              return /^[\da-zA-Z\a-zA-ZùÙüÜáčďéěíňóřšťúůýžäáčďéěíňóřšťúůýžàáëèéïìíöòóüùúÄÀÅÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]{1,32}$/.test(value) 
            } else {
              if (!value) return true
              return /^[\da-zA-Z\s-/]{1,32}$/.test(value)  
            } 
           }
          },
          line2: {
            Addressline2 (value) {
              if (!value) return true
              return /^[\da-zA-Z\a-zA-ZùÙüÜáčďéěíňóřšťúůýžäàáčďéěíňóřšťúůýžáëèéïìíöòóüùúÄÅÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÀÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]{0,15}$/.test(value)
            }
          },
          city: {
            required,
            town (value) {
            if(this.selectedCountry.code === 'ES' || this.selectedCountry.code === 'AT' || this.selectedCountry.code === 'FR' || this.selectedCountry.code === 'SE' || this.selectedCountry.code === 'RO' || this.selectedCountry.code === 'CZ' || this.selectedCountry.code === 'BE'){
              if (!value) return true
              return /^[\da-zA-Z\a-zA-ZùÙüÜáčďéěíňóřšťúůýžäáčďéěíňóřšťúůýžàáëèéïìíöòóüùúÄÀÅÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]{1,32}$/.test(value) 
            } else {
              if (!value) return true
              return /^[a-zA-Z\s-]{1,20}$/.test(value) 
            }             
           }
          },
          county: {
            required
          },
          zipCode: {
            required,
            zipCode (value) {
              if (!value) return true
              return this.selectedCountry.zipCodeRegex.test(value)
            }
          }
        }
      } else {
        AddressObject = {
          street: {
            required (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return !!value
              } else {
                return true
              }
            },
            address (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return !addressRegex.test(value)
              } else {
                return true
              }
            },
            maxLength: maxLength(22),
            minLength: minLength(2)
          },
          addition: {
            required (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 1) {
                return !!value
              } else {
                return true
              }
            },
            includeNumber (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 1) {
                return includeNumberRegex.test(value)
              } else {
                return true
              }
            },
            address (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 1) {
                return !addressRegex.test(value)
              } else {
                return true
              }
            },
            maxLength: maxLength(35),
            minLength: minLength(4)
          },
          extension: {
            maxLength: maxLength(9)
          },
          selectedCountry: {
            required
          },
          selectedCountryState: {
            required (value) {
              if (this.selectedCountry.states) {
                return !!value
              } else {
                return true
              }
            }
          },
          zipCode: {
            required,
            zipCode (value) {
              if (!value) return true
              return this.selectedCountry.zipCodeRegex.test(value)
            }
          },
          city: {
            required,
            maxLength: maxLength(20),
            minLength: minLength(2)
          },
          houseNumber: {
            required (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return !!value
              } else {
                return true
              }
            },
            houseNumber (value) {
              if (this.selectedCountry.street_housenumber_extension_field === 3) {
                return this.selectedCountry.houseNumberRegexs.test(value)
              } else {
                return true
              }
            }
          }
        }
      }
      return { ...AddressObject }
    },

    computed: {
      ...mapState('subscription', ['subscriptionDetails']),

      ...mapState('culture', ['countries']),

      ...mapValueProperties('address', [
        'countryCode',
        'stateCode',
        'city',
        'zipCode',
        'addition',
        'street',
        'houseNumber',
        'extension',
        'line1',
        'line2',
        'county'
      ], { modifyOriginal: true }),

      selectedCountry: {
        get () {
          return this.countries.length === 1 ? this.countries[0] : this.countryCode &&
            this.countries.find(country => country.code === this.countryCode)
        },

        set (selectedCountry) {
          this.countryCode = selectedCountry.code
          this.stateCode = null
        }
      },

      selectedCountryState: {
        get () {
          if (this.currentCountryCode === 'GB') {
            return this.selectedCountry.states &&
              this.county &&
              this.selectedCountry.states.find(state => state.name === this.county)
          }
            else if (this.currentCountryCode === 'IT' || this.currentCountryCode === 'US' || this.currentCountryCode === 'CA') {
            return this.selectedCountry.states &&
              this.stateCode &&
              this.selectedCountry.states.find(state => state.code === this.stateCode)    
          } else {
            return this.selectedCountry.states &&
              this.stateCode &&
              this.selectedCountry.states.find(state => state.name === this.stateCode)
          }
        },

        set (selectedCountryState) {
          if (this.currentCountryCode === 'GB') {
            this.county = selectedCountryState.name
          }
          else if (this.currentCountryCode === 'IT' || this.currentCountryCode === 'US' || this.currentCountryCode === 'CA') {
            this.stateCode = selectedCountryState.code
          } else {
            this.stateCode = selectedCountryState.name
          }
        }
      },

      initialCancelReason () {
        return this.subscriptionDetails.cancelReasonOptions.map(item => ({
          text: item,
          checked: false
        }))
      },

      cancelReasonSelected () {
        let cancelReasonSelected = ''
        this.cancelReason.find(item => {
          if (item.checked) {
            cancelReasonSelected = cancelReasonSelected + item.text + ';'
          }
        })
        return cancelReasonSelected.substring(0, cancelReasonSelected.length - 1)
      },

      consumerEmail () {
        return JSON.parse(window.sessionStorage.getItem('personalDetail')).email
      }
    },

    methods: {
      errorsFor (field) {
        if (!this.showValidations) {
          return []
        }

        if (this.$v[field] == null) {
          return []
        }

        return getErrors(this.$v[field])
      },

      searchState (query, conuntryCode) {
        this.$store.commit('culture/filterStates', { query, conuntryCode })
      },

      emptyCancelData () {
        this.cancelReason = cloneDeep(this.initialCancelReason)
        this.cancelMoreInfo = ''
        this.currentIndex = -1
        this.step1Show = false
        this.cancelOption = null
      },

      closeModalStep2 () {
        this.$bus.$emit('close-modal', 'step2')
        this.cancelReason = cloneDeep(this.initialCancelReason)
        this.cancelMoreInfo = ''
        this.hideChecked = true
        this.currentIndex = -1
        this.step1Show = false
        this.cancelOption = null
      },

      startReturnOnlyTryBuy () {
        this.$bus.$emit('open-modal', 'step2')
      },

      editAddress () {
        if (!this.editable) {
          this.editable = true
          this.preEditAddress = cloneDeep(this.address)
          this.$bus.$emit('open-modal', 'step5')
          this.$bus.$emit('close-modal', 'checkReturnAddress')
        } else {
          this.editable = false
          this.address = this.preEditAddress
        }
      },

      submitCheckReturnAddress () {
        this.$bus.$emit('close-modal', 'checkReturnAddress')
        this.$bus.$emit('open-modal', 'step3')
      },

      cancleSubmitCheckReturnAddress () {
        this.$bus.$emit('close-modal', 'checkReturnAddress')
        this.emptyCancelData()
      }
    },

    tasks (t) {
      return {
        openModalStep2: t(async function () {
          // callback draft return api
          if (this.subscriptionDetails.contentProductName === 'Lumea' && this.currentCountryCode === 'GB') {
            await Vue.api.subscription.returnTryBuyBundledReturn(this.subscriptionDetails.number, 'TryBuy', this.cancelReasonSelected, this.cancelMoreInfo)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'step2')
          } else {
            await Vue.api.subscription.returnTryBuySubscription(this.subscriptionDetails.number, 'TryBuy', this.cancelReasonSelected, this.cancelMoreInfo)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'step2')
          }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        submitUpdateReturnAddress: t(async function () { // update re-address
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.showValidations = true
          } else {
            this.editable = false
          }
          if (this.street && this.houseNumber && this.extension && this.street.concat(this.houseNumber, this.extension).length > 4 && this.street.concat(this.houseNumber, this.extension).length < 35) {
            await Vue.api.subscription.updateReturnAddress2('TryBuy', this.subscriptionDetails.number, this.address)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.updateAddressSuccess = true
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'step5')
          } else {
            await Vue.api.subscription.updateReturnAddress2('TryBuy', this.subscriptionDetails.number, this.address)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.updateAddressSuccess = true
            this.$bus.$emit('open-modal', 'checkReturnAddress')
            this.$bus.$emit('close-modal', 'step5')
          }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        cancelUpdateReturnAddress: t(async function () { // cancel update address
          this.$bus.$emit('open-modal', 'checkReturnAddress')
          this.$bus.$emit('close-modal', 'step5')
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        cancelOrReturnOnlyReplenishmentTask: t(async function () {
          this.trackConversion({
            name: 'interaction',
            description: `${this.cancelReasonSelected.replace(/\s/gi, '_')}:cancel_your_subscription`
          })
          if (this.street && this.houseNumber && this.extension && (this.street.concat(this.houseNumber, this.extension).length > 4) && (this.street.concat(this.houseNumber, this.extension).length < 35)) {
            await Vue.api.subscription.updateReturnAddress2('TryBuy', this.subscriptionDetails.number, this.address)
            const { replenishmentCarriers, tryBuyCarriers } = await Vue.api.subscription.getReturnCarries(this.subscriptionDetails.number, 'TryBuy')
            const tryBuyCarrier = tryBuyCarriers && tryBuyCarriers[0]
            const replenishmentCarrier = replenishmentCarriers && replenishmentCarriers[0]
            await Vue.api.subscription.submitReturnCarrier(this.subscriptionDetails.number, tryBuyCarrier, replenishmentCarrier)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('close-modal', 'checkReturnAddress')
            this.emptyCancelData()
          } else {
            await Vue.api.subscription.updateReturnAddress2('TryBuy', this.subscriptionDetails.number, this.address)
            const { replenishmentCarriers, tryBuyCarriers } = await Vue.api.subscription.getReturnCarries(this.subscriptionDetails.number, 'TryBuy')
            const tryBuyCarrier = tryBuyCarriers && tryBuyCarriers[0]
            const replenishmentCarrier = replenishmentCarriers && replenishmentCarriers[0]
            await Vue.api.subscription.submitReturnCarrier(this.subscriptionDetails.number, tryBuyCarrier, replenishmentCarrier)
            await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionDetails.number)
            this.$bus.$emit('close-modal', 'checkReturnAddress')
            this.emptyCancelData()
          }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        })
      }
    },

    created () {
      this.cancelReason = cloneDeep(this.initialCancelReason)
      Vue.api.subscription.getReturnAddress2().then(data => {
        this.address = data
      }).catch(error => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
    }
  }
</script>
